import axios from "axios";
import formatNumberWithCommas from "../format/formatNumberWithCommas";

const EmailSender = async (billData, checkSuccess) => {
  if (checkSuccess) {
    const message = formatNumberWithCommas(billData.TotalPayment);
    const data = {
      service_id: "service_29aeezr",
      template_id: "template_213a4v1",
      user_id: "g9EVqnw5xY4megm_h",
      template_params: {
        message: message,
      },
    };

    try {
      await axios.post(
        "https://api.emailjs.com/api/v1.0/email/send",
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) {
      console.error('Oops... ' + JSON.stringify(error.response.data));
    }
  }
};

export default EmailSender;
